import React from 'react';
import {
    ProductStore,
    RequestStore,
    LoyaltyStore,
    FavoritesStore,
    DiscountStore,
    HeaderStore,
    OrderStore,
    CartStore,
    ProfileDataStore,
    ProfileOrderStore,
    LoginStore,
    RegisterStore,
    RecoveryStore,
    InstructionsStore,
    ServiceStore,
} from '../stores';

export const stores = {
    ProductStore: new ProductStore(),
    RequestStore: new RequestStore(),
    LoyaltyStore: new LoyaltyStore(),
    FavoritesStore: new FavoritesStore(),
    DiscountStore: new DiscountStore(),
    HeaderStore: new HeaderStore(),
    OrderStore: new OrderStore(),
    CartStore: new CartStore(),
    ProfileDataStore: new ProfileDataStore(),
    ProfileOrderStore: new ProfileOrderStore(),
    LoginStore: new LoginStore(),
    RegisterStore: new RegisterStore(),
    RecoveryStore: new RecoveryStore(),
    InstructionsStore: new InstructionsStore(),
    ServiceStore: new ServiceStore(),
};

export const storesContext = React.createContext(stores);
